<script type="ts">
	// Import Modules
	import { browser } from '$app/environment';
	import { handleRedirect, isLoggedIn, login, logout } from '$lib/components/auth/auth';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';

	// Import Components
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import ActiveCircleRed from '$lib/img/branding/logos/active_circle_red.svelte';

	// Auth
	async function authFunc() {
		if (browser) {
			await login();
		} else {
			console.log('Cannot auth in non-browser environment.');
		}
	}

	async function handleRedir() {
		if (browser) {
			const response = await handleRedirect();
			if (response.accessToken) {
				location.reload();
			}
		}
	}

	handleRedir();
</script>

<MetaTags title="Sign In" />

<Wrapper title="Login" transparent>
	<div class="pt-8" />
	<div class="relative z-0 mx-auto mt-8 max-w-4xl rounded-md bg-white pb-4 pt-4">
		<div
			class="relative z-10 ml-auto mr-auto mt-[-3rem] h-20 w-20 rounded-full border-2 border-red-700 bg-white p-2"
		>
			<ActiveCircleRed />
		</div>
		<h2 class="mb-4 mt-4 text-center text-neutral-900 dark:text-white">Login or Signup</h2>
		<div class="m-auto px-4">
			{#await isLoggedIn()}
				<button
					type="button"
					on:click={authFunc}
					on:keydown={authFunc}
					class="w-full rounded-full border border-red-600 px-4 py-2 text-red-600 hover:border-red-900"
				>
					Log In
				</button>
			{:then userObject}
				{#if userObject}
					<button
						type="button"
						on:click={logout}
						on:keydown={logout}
						class="w-full rounded-full border border-red-600 px-4 py-2 text-red-600 hover:border-red-900"
					>
						Log Out
					</button>
					<div class="mt-8" />
					<p class="text-center">Account settings are currently being worked on.<br />You can manage your email and password via <a href="https://auth.activegym.com.au/realms/activegymnastics/account/" class="font-semibold text-red-600">Active One Auth</a>.</p>
				{:else}
					<button
						type="button"
						on:click={authFunc}
						class="w-full rounded-full border border-red-600 px-4 py-2 text-red-600 hover:border-red-900"
					>
						Log In
					</button>
				{/if}
			{/await}
		</div>
	</div>
</Wrapper>
